import { Injectable } from "@angular/core";

import { AggregateHelperService, IAggregateActionHandler } from "@tylertech/aggregates-module";
import { GeneralLedgerDialogService } from "@tylertech/general-ledger-module";
import { IAggregate, ICardData, ICardAction, BaseItem } from "@tylertech/tyler-api-types";

import { PayableService } from "../services";

@Injectable()
export class InvoiceApprovalActionHandler implements IAggregateActionHandler
{
    constructor(
        private readonly $aggregateHelperService: AggregateHelperService,
        private readonly $generalLedgerDialogService: GeneralLedgerDialogService,
        private readonly $payableService: PayableService,
    ) { }

    predicate(aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return aggregate.AggregateProviderId === "AccountsPayable.InvoiceApprovals" && action.Id === "BudgetRecap";
    }

    execute(_aggregate: IAggregate, cardData: ICardData, _action: ICardAction): Promise<boolean>
    {
        const id = this.$aggregateHelperService.getFieldValue(cardData, "Id");
        return this.$payableService.GetItems(id)
            .then((items: BaseItem[]) =>
            {
                const issued = new Date(this.$aggregateHelperService.getFieldValue(cardData, "Issue Date"));
                return this.$generalLedgerDialogService.showAccountBudgetRecap(items, issued);
            });
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
